import { createAsyncThunk } from "@reduxjs/toolkit";
import { get, put } from "../../Services/ApiBase";
import { API_ENDPOINTS } from "../../Services/ApiEndPoints";
import { getApiErrorMessage } from "../../utils/apiErrorMessage";

export const fetchPermissionsData = createAsyncThunk(
  "permissions/fetchData",
  async (_, { rejectWithValue }) => {
    try {
      const response = await get(API_ENDPOINTS.PERMISSIONS.GET_ALL);
      return response.data;
    } catch (error) {
      return rejectWithValue(getApiErrorMessage(error, "Failed to fetch permissions data"));
    }
  }
);

export const fetchRolePermissions = createAsyncThunk(
  "permissions/fetchByRole",
  async (roleId, { rejectWithValue }) => {
    try {
      const endpoint = API_ENDPOINTS.PERMISSIONS.GET_BY_ROLE(roleId);
      const response = await get(endpoint);
      return response.data;
    } catch (error) {
      return rejectWithValue(getApiErrorMessage(error, "Failed to fetch role permissions"));
    }
  }
);

export const updateRolePermissions = createAsyncThunk(
  "permissions/updateRolePermissions",
  async ({ roleId, permissions }, { rejectWithValue }) => {
    try {
      const endpoint = API_ENDPOINTS.PERMISSIONS.UPDATE_ROLE_PERMISSIONS(roleId);
      const permissionIds = Array.isArray(permissions) ? permissions : [];
      const response = await put(endpoint, { permissionIds });
      return response.data;
    } catch (error) {
      return rejectWithValue(getApiErrorMessage(error, "Failed to update role permissions"));
    }
  }
);
